import React, { Component } from 'react'
import Accounts from '../components/money/Accounts';
import Investments from '../components/money/Investments';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import { CardContent, Dialog, DialogTitle, Divider, IconButton } from "@mui/material";
import YoutubeEmbed from "../YoutubeEmbed";

export class Money extends Component {
    constructor(props) {
		super(props);
		this.state = {
			open:false,
			embelUrl: "",
		}
	}
	setEmbedUrl = (url) => {
		this.setState({ embelUrl: url, open: true });
	}
    render() {
        return (
            <>
                { this.props.tab === "accounts" ? 
                    <Accounts openSweep={this.props.openSweep} max_save={true} gid={this.props.gid} setEmbedUrl={this.setEmbedUrl} /> : 
                    <Investments gid={this.props.gid} /> }
                    <Dialog
                        open={this.state.open}
                        onClose={() => this.setState({ open: false, embelUrl: "" }) }
                        sx={{ borderRadius: "30px" }}
                    >
						<DialogTitle  sx={{ fontSize: "1rem" , display:"flex", alignItems:"flex-start", justifyContent:"space-between", margin: 0}}>See how this works
                <IconButton
                            aria-label="close"
                            onClick={() => this.setState({ open: false, embelUrl: "" })}
                            sx={{
                               padding:0,
                                color: (theme) => theme.palette.grey[500],
                            }}
                            >
                            <CloseRoundedIcon />
                            </IconButton>
                </DialogTitle>
                <Divider light />
                <CardContent sx={{ width: "40vw" }} className="tutorial-container">
					<YoutubeEmbed embelUrl={this.state.embelUrl} />
                </CardContent>
                    </Dialog>
            </>
        )
    }
}

export default Money
